module.exports = __webpack_public_path__ + "assets/citrix-netscaler.d790fb1a.svg";